import axios from "axios";
import { apiKey } from "./config";

let language;

async function fetchLanguage() {
  try {
    const res = await axios.get(`${apiKey}/api/rms/customer/language`);

    language = {
      ...res.data[0],
      text_en: JSON.parse(res.data[0].text_en),
      text_ar: JSON.parse(res.data[0].text_ar),
    };
  } catch (err) {
    console.log(err);
  }
}

fetchLanguage();

export function languageHelper(lang, key) {
  if (!language) return false;
  return language[lang]?.[key] || false;
}
